<template>
    <div class="collect-data-container">
        <div class="overlay"></div>
        <div class="bg">
            <h2>{{ params.title }}</h2>
            <div class="input-container" :class="hasError ? 'error-shake' : ''" v-if="!['confirmation', 'dialog', 'options'].includes(params.type)">
                <div id="data" class="div-input-android" :class="{ 'error-signal': hasError }"></div>
                <span v-if="this.message" class="message"> {{ this.message }}</span>
            </div>

            <div class="main-area" v-if="['options'].includes(params.type)">
                <div class="funcoes-administrativas-options">
                    <span class="option" v-for="(option, key) in optionsData" :key="key" @click="confirm(key + 1)">{{ option }}</span>
                </div>
            </div>

            <div class="buttons-container">
                <DefaultButton v-for="(btn, key) in getButtons()" :key="key" :disabled="!controlsEnabled" :text="btn.text" @defaultBtnClick="btn.action(btn.value)"
                    class="buttons">
                </DefaultButton>
            </div>

            <AndroidKeyboard v-if="!['confirmation', 'dialog', 'options'].includes(params.type)" id="android-keyboard" :inputElement="inputElement" :layout="layout" :bigNumeric="true"
                :onInput="applyMask">
            </AndroidKeyboard>
        </div>
    </div>
</template>

<script>
import DefaultButton from '@/components/DefaultButton.vue'
import LocaleController from '@/assets/controllers/LocaleController'
import AndroidKeyboard from '@/components/AndroidKeyboard/AndroidKeyboard'
import keyboardLayout from '@/assets/libs/keyboardLayout'
import PaymentController from '@/assets/controllers/PaymentController'
import eventModule from '@/assets/libs/eventModule'
/* methods: confirmation, dialog, text, options */
export default {
    name: 'CollectDataModal',
    components: {
        DefaultButton,
        AndroidKeyboard
    },
    props: ['params'],
    data () {
        return {
            inputElement: null,
            visible: false,
            options: {
                useKbEvents: false,
                preventClickEvent: false
            },
            layout: keyboardLayout.SIMPLE_PHONE_NUMBER,
            input: null,
            buttons: [
                {
                    text: this.getString('cancelar'),
                    action: this.cancel,
                    value: '',
                    visible: true
                },
                {
                    text: this.getString('confirmar'),
                    action: this.confirm,
                    value: '',
                    visible: true
                }
            ],
            hasError: false,
            controlsEnabled: true,
            message: '',
            optionsData: [],
            tefMessage: ''
        }
    },
    created () {
        // eventModule.$on('setTefMessage', this.setTefMessage)
        this._tefHandler = (msg) => {
            this.setTefMessage(msg)
        }
        eventModule.$on('setTefMessage', this._tefHandler)
    },
    beforeDestroy () {
        eventModule.$off('setTefMessage', this._tefHandler)
    },
    mounted () {
        this.inputElement = document.getElementById('data')
        if (this.params.type === 'confirmation') {
            this.buttons[1].value = '0'
            this.buttons[0].text = this.getString('ok')
            this.buttons[0].visible = false
        }
        if (this.params.type === 'dialog') {
            // para a fisica, 0 significa confirmar e 1 significa cancelar
            this.buttons[0].value = '1'
            this.buttons[0].action = this.confirm
            this.buttons[1].value = '0'
        }

        if (this.params.type === 'options') {
            this.buttons[1].visible = false
            this.buttons[0].visible = true
            this.buttons[0].action = this.cancel
            this.optionsData = this.params.options.split(';')
            this.optionsData = this.optionsData.filter(option => option && option.length > 0)
            console.log('optionsData', this.optionsData)
        }
    },
    methods: {
        getString: function (key) {
            return LocaleController.getString(key)
        },
        getButtons: function () {
            return this.buttons.filter(e => e.visible)
        },
        confirm: async function (btnVal) {
            let value = btnVal || this.inputElement.innerText
            if (!this.validInput(value)) {
                this.hasError = true
                this.showError()
                return false
            }
            PaymentController.setCollectDataModalData(value)
            PaymentController.setWaitingForData(false)
            this.$emit('closeCollectDataModal')
        },
        cancel: async function () {
            PaymentController.clearCancelTefData()
            PaymentController.cancelPayment()
            this.$emit('closeCollectDataModal')
        },
        validInput: function (value) {
            if (this.params.type === 'confirmation' || this.params.type === 'dialog' || this.params.type === 'options') {
                return true
            }
            let minLength = this.params.minLength || 0
            let maxLength = this.params.maxLength || 100
            value = value.replace(/\D/g, '')
            return value.length >= minLength && value.length <= maxLength
        },
        applyMask: function (input) {
            if (!input) return ''

            let maxLength = this.params.maxLength || 0

            if (this.params.type === 'date') {
                // Máscara para data: DD/MM/AAAA (limite de 8 dígitos)
                input = input.replace(/\D/g, '')
                if (input.length > maxLength) {
                    input = input.substring(0, maxLength)
                }
                if (input.length >= 2) {
                    input = input.replace(/(\d{2})(\d)/, '$1/$2')
                }
                if (input.length >= 5) {
                    input = input.replace(/(\d{2})\/(\d{2})(\d)/, '$1/$2/$3')
                }
                return input
            }

            if (this.params.type === 'number') {
                // Máscara para números decimais: 1.234,56 (limite de 10 dígitos)
                input = input.replace(/[^\d]/g, '')
                if (input.length > maxLength) {
                    input = input.substring(0, maxLength)
                }
                if (input.length > 0) {
                    // Adiciona vírgula para centavos se necessário
                    if (input.length > 2) {
                        input = input.replace(/(\d+)(\d{2})$/, '$1,$2')
                    }
                    // Adiciona pontos para milhares
                    if (input.length > 6) {
                        input = input.replace(/(\d+)(\d{3}),(\d{2})$/, '$1.$2,$3')
                    }
                }
                return input
            }

            if (this.params.type === 'text') {
                // Para texto, limita a 100 caracteres
                maxLength = maxLength || 100
                if (input.length > maxLength) {
                    input = input.substring(0, maxLength)
                }
                return input
            }

            if (this.params.type === 'tel') {
                // Máscara para telefone: (11) 99999-9999 ou (11) 9999-9999 (limite de 11 dígitos)
                input = input.replace(/\D/g, '')
                if (input.length > 11) {
                    input = input.substring(0, 11)
                }
                if (input.length >= 2) {
                    input = input.replace(/(\d{2})(\d)/, '($1) $2')
                }
                if (input.length >= 7) {
                    // Celular (9 dígitos após DDD)
                    if (input.length >= 11) {
                        input = input.replace(/(\d{2})\s(\d{5})(\d)/, '$1 $2-$3')
                    } else {
                        // Fixo (8 dígitos após DDD)
                        input = input.replace(/(\d{2})\s(\d{4})(\d)/, '$1 $2-$3')
                    }
                }
                return input
            }

            if (this.params.type === 'cpf') {
                // Máscara para CPF: 000.000.000-00 (limite de 11 dígitos)
                input = input.replace(/\D/g, '')
                if (input.length > 11) {
                    input = input.substring(0, 11)
                }
                if (input.length >= 4) {
                    input = input.replace(/(\d{3})(\d)/, '$1.$2')
                }
                if (input.length >= 7) {
                    input = input.replace(/(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
                }
                if (input.length >= 10) {
                    input = input.replace(/(\d{3})\.(\d{3})\.(\d{3})(\d)/, '$1.$2.$3-$4')
                }
                return input
            }

            if (this.params.type === 'cnpj') {
                // Máscara para CNPJ alfanumérico: AA.BBB.CCC/DDDD-EE (suporta A-Z0-9)
                input = input.replace(/[^a-zA-Z0-9]/g, '').toUpperCase()

                if (input.length > 18) {
                    input = input.substring(0, 18)
                }

                if (input.length < 6) {
                    input = input.replace(/([A-Z0-9]{2})([A-Z0-9])/, '$1.$2')
                } else if (input.length >= 6 && input.length < 9) {
                    input = input.replace(/([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9])/, '$1.$2.$3')
                } else if (input.length >= 9 && input.length < 13) {
                    input = input.replace(/([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9])/, '$1.$2.$3/$4')
                } else {
                    input = input.replace(/([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})([A-Z0-9]{2})/, '$1.$2.$3/$4-$5')
                }
                return input
            }

            if (this.params.type === 'currency') {
                // Máscara para moeda: R$ 1.234,56 (limite de 10 dígitos)
                input = input.replace(/[^\d]/g, '')
                if (input.length > 10) {
                    input = input.substring(0, 10)
                }
                if (input.length > 0) {
                    // Converte para centavos
                    let value = parseInt(input)
                    let formatted = (value / 100).toFixed(2)
                    formatted = formatted.replace('.', ',')
                    formatted = formatted.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
                    return 'R$ ' + formatted
                }
                return 'R$ 0,00'
            }

            // Retorna o input original se não houver tipo específico
            return input
        },
        clearMessage: function () {
            setTimeout(() => {
                this.hasError = false
                this.message = ''
            }, 2000)
        },
        showError: function () {
            this.message = this.getString('dados_invalidos')
            this.clearMessage()
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>
@import (reference) url("../assets/common.less");

.collect-data-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    padding: 20px;
    box-sizing: border-box;

    .bg {
        position: relative;
        background: @white;
        padding: 30px;
        border-radius: 25px;
        box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.1);
        max-width: calc(100vw - 300px);
        width: 100%;
        max-height: calc(100vh - 40px);
        overflow-y: auto;
        opacity: 1;
        z-index: 1000;
        #android-keyboard {
            margin: 15px;
        }
        img {
            display: block;
            margin: auto;
            width: 100px;
            height: 100px;
            border: solid 1px;
            border-radius: 100%;
            object-fit: contain;
            padding: 10px;
        }

        h2,
        span,
        img {
            display: block;
            font-size: 2rem;
            margin: auto;
            text-align: center;
            opacity: 1;
        }
        span {
            // line-height: 50px;
            margin: 0 15px;
        }
        h2,
        span.qst {
            margin: 15px 0;
            font-weight: bold;
        }

        .input-container {
            margin: 40px 15px;
            text-align: center;

            .div-input-android {
                position: relative;
                margin: 50px 30px;
                display: block;
                font-size: 4rem;
                height: 85px;
                background-color: white;
                color: black;
                border: 2px solid black;
                border-radius: 20px;
                padding: 0 20px;

                &.error-shake {
                    input {
                        background-color: rgba(250, 9, 9, 0.397);
                    }

                    animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
                    transform: translate3d(0, 0, 0);
                }
            }
            .message {
                font-size: 25px;
            }

            .error-signal {
                border: 4px solid red;
                animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
                transform: translate3d(0, 0, 0);
            }
        }
        .main-area {
                flex-grow: 1;
                display: flex;
                flex-direction: column;
                overflow: hidden auto;
                padding-left: 25px;
                position: relative;
                .funcoes-administrativas-options {
                    display: flex;
                    flex-direction: column;
                    align-items: left;
                    // align-items: center;
                    justify-content: center;
                    .option {
                        display: flex;
                        padding: 10px;
                        align-items: center;
                        border-bottom: 1px solid black;
                        justify-content: left;
                    }
                }
                .screen-printed {
                    font-size: 25px;
                    margin: auto;
                }

                .sale-type-radios {
                    .option {
                        display: flex;
                        margin-top: 15px;
                        align-items: center;
                        grid-template-columns: 20% 80%;
                    }
                }

                .label-text {
                    font-size: 30px;
                }
                .sales-table {
                    width: 98%;
                    th, td {
                        padding: 10px 5px;
                        text-align: center;
                    }
                    th {
                        font-weight: normal;
                        border-bottom: 1px solid black;
                    }
                    tr:nth-child(even) {
                        background-color: #f2f2f2;
                    }
                }
        }

        .buttons-container {
            margin: 20px 0;
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            align-content: center;
            justify-content: space-around;
            align-items: center;

            button:not(:last-of-type) {
                background: white;
                border: solid 1px black;
                color: black;
            }

            button {
                margin: 10px;
            }
        }
    }

    .overlay {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        background: rgba(0, 0, 0, 0.8);
        z-index: 30;
        will-change: background-color;
        -webkit-transition: background-color 1s ease-in-out;
        transition: background-color 1s ease-in-out;
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
    }

    #keyboard {
        .keyboard;
        width: inherit;
        max-width: 930px;
        top: inherit;
        position: unset;
        bottom: 0;
    }

    @keyframes shake {

        10%,
        90% {
            transform: translate3d(-1px, 0, 0);
        }

        20%,
        80% {
            transform: translate3d(2px, 0, 0);
        }

        30%,
        50%,
        70% {
            transform: translate3d(-4px, 0, 0);
        }

        40%,
        60% {
            transform: translate3d(4px, 0, 0);
        }
    }
}

@media (max-width: 698px) {

    // Gertec SK210
    .collect-data-container {
        padding: 10px;

        .bg {
            max-width: 400px;
            padding: 20px;

            img {
                width: 50px;
                height: 50px;
            }

            img {
                font-size: 20px;
            }

            h2 {
                font-size: 20px;
                margin: 10px 0;
            }

            span {
                font-size: 18px;
            }

            .input-container {
                margin: 20px 0;

                .div-input-android {
                    margin: 0 20px;
                    font-size: 22px;
                    height: 35px;
                    padding: 5px 10px 0 10px;
                    width: auto;
                }
            }

            .buttons-container {
                margin: 10px 0;
                .buttons {
                    max-width: 150px;
                }
            }
            .main-area {
                flex-grow: 1;
                padding-left: 10px;
                position: relative;
                max-height: 60vh;
                .funcoes-administrativas-options {
                    .option {
                        display: flex;
                        padding: 7px;
                        align-items: center;
                        border-bottom: 1px solid black;
                        justify-content: left;
                        font-size: 16px;
                    }
                }
                .screen-printed {
                    font-size: 18px;
                    margin: auto;
                }

                .sale-type-radios {
                    .option {
                        display: flex;
                        margin-top: 15px;
                        align-items: center;
                        grid-template-columns: 20% 80%;
                    }
                }

                .label-text {
                    font-size: 30px;
                }
                .sales-table {
                    width: 98%;
                    th, td {
                        padding: 10px 5px;
                        text-align: center;
                    }
                    th {
                        font-weight: normal;
                        border-bottom: 1px solid black;
                    }
                    tr:nth-child(even) {
                        background-color: #f2f2f2;
                    }
                }
            }
        }
    }
}

@media (min-width: 901px) and (max-width: 1025px) {

    //@tablet
    .collect-data-container {
        padding: 30px;
        .bg {
            #android-keyboard {
                margin: 5px;
            }
            span {
                font-size: 30px;
            }
            .input-container {
                margin: 30px 15px;

                .div-input-android {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    height: 60px;
                    margin: 30px 0;
                    font-size: 40px;
                }
            }
        }
    }
}

@media (min-width: 699px) and (max-width: 900px) {
//@mehloretec
    .collect-data-container {
        padding: 25px;
        .bg {
            max-width: calc(100vw - 190px);
            #android-keyboard {
                margin: 5px;
            }
            span {
                font-size: 25px;
            }
            .input-container {
                margin: 25px 15px;

                .div-input-android {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    height: 60px;
                    margin: 25px 0;
                    font-size: 30px;
                }
            }
            .buttons-container {
                margin: 10px 0;
                .buttons {
                    // max-width: 220px;
                    width: 220px;
                    min-width: 220px;
                }
            }
        }
    }
}

@media (orientation: landscape) {
    .collect-data-container {
        padding: 10px;

        .bg {
            max-width: 550px;
            padding: 20px;

            img {
                width: 50px;
                height: 50px;
            }

            img {
                font-size: 20px;
            }

            h2 {
                font-size: 22px;
                margin: 10px 0;
            }

            span {
                font-size: 18px;
            }

            .input-container {
                margin: 20px 0;

                .div-input-android {
                    margin: 0 auto;
                    font-size: 22px;
                    height: 35px;
                    padding: 5px 10px 0 10px;
                    width: 430px;
                }
            }

            .buttons-container {
                margin: 10px 0;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/CollectDataModal.vue